// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const moduleWrapper = "ModuleWrapper2020__moduleWrapper__qx-wd";
export const insights = "ModuleWrapper2020__insights__KAnHf";
export const flexLayout = "ModuleWrapper2020__flexLayout__cVX7G";
export const noPadding = "ModuleWrapper2020__noPadding__HBdKR";
export const withPaddingBottom = "ModuleWrapper2020__withPaddingBottom__uDDNc";
export const header = "ModuleWrapper2020__header__oaCly";
export const blockName = "ModuleWrapper2020__blockName__v91Kb";
export const title = "ModuleWrapper2020__title__84bKk";
export const subtitle = "ModuleWrapper2020__subtitle__0pceR";
export const rightArrow = "ModuleWrapper2020__rightArrow__U6B1e";
export const headerInner = "ModuleWrapper2020__headerInner__4-OIf";
export const tooltipIconWrapper = "ModuleWrapper2020__tooltipIconWrapper__Z58aJ TooltipIcon__tooltipIconWrapper__oUGNC";
export const withChevron = "ModuleWrapper2020__withChevron__4-toB";